import { User } from "@/graphql/types";
import { InjectionKey } from "@vue/composition-api";

export const ProfileKey: InjectionKey<User> = Symbol();
